import React, { useState } from "react";
import Layout from "../component/Layout/Layout";
import { useAuth } from "../context/auth";
import Measurements from "./Measurements";
const MyMeasurement = () => {
  const [auth] = useAuth();
  //const [userId] = useState(auth?.user.id);
  console.log(auth);

  if (auth?.user) {
    return <Measurements />;
  } else {
    return (
      <Layout
        title="Measurements | Chaashni Couture">
        <div className="site-content-wrap my-account">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1 className="sustom-heading-h1">Measurements</h1>
                <div className="content-box">
                  <div className="video-box-measurment">
                    <div className="video-box-text">
                      <p>
                        Please closely follow the video to record your
                        measurements.
                        <br />
                        Whilst you can do it your own, we suggest taking help
                        for more accuracy.
                      </p>
                    </div>

                    <div className="video-box-video youtube-video-wrap">
                      <div className="youtube-video-wrap hi">
                        <img
                          src="/images/youtube-img.jpg"
                          alt=""
                          loading="lazy"
                        />
                        <iframe
                          width="560"
                          height="315"
                          src="https://www.youtube.com/embed/sYt-m98__Vc?rel=0"
                          title="YouTube video player"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen=""
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
};

export default MyMeasurement;
